import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import ArticleSection from './components/ArticleSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kakobuypolska.rest';

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Kakobuy Polska Spreadsheet',
    url: siteUrl,
    description: 'Niezależny przewodnik Kakobuy Spreadsheet dla polskich użytkowników. Znajdź najlepsze produkty, aktualne finds i poradniki zakupowe.',
    sameAs: ['https://kaspreadsheet.com'],
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    url: siteUrl,
    name: 'Kakobuy Spreadsheet Polska 2026 | Najlepsze Finds, Lista Produktów i Poradnik',
    description: 'Kakobuy Spreadsheet Polska – znajdź najlepsze produkty, aktualne finds, linki, poradniki zakupowe i informacje o bezpieczeństwie Kakobuy.',
    inLanguage: 'pl',
    isPartOf: {
      '@type': 'WebSite',
      name: 'Kakobuy Polska Spreadsheet',
      url: siteUrl,
    },
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryDropdown />
        <CategoryGrid />
        <ArticleSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}